import { createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { API } from '../../constants'
import { application } from '../../services/application'

// ── Initial State ───────────────────────────────────────────────────────────────
export const INITIAL_STATE = {
  governmentResources: [],
  governmentResourceDetail: {},

  // newly added slice for agency links
  agencyLinks: []
}


// ── Thunks: Government Resources ────────────────────────────────────────────────
export const getGovernmentResourcesList = createAsyncThunk(
  'governmentResources/getList',
  params => application.call(API.GOVERNMENT_RESOURCES.GET_LIST, params)
)
export const getGovernmentResource = createAsyncThunk(
  'governmentResources/getOne',
  params => application.call(API.GOVERNMENT_RESOURCES.FIND_ONE, params)
)
export const createGovernmentResource = createAsyncThunk(
  'governmentResources/create',
  params => application.call(API.GOVERNMENT_RESOURCES.CREATE, params)
)
export const updateGovernmentResource = createAsyncThunk(
  'governmentResources/update',
  params => application.call(API.GOVERNMENT_RESOURCES.UPDATE, params)
)
export const deleteGovernmentResource = createAsyncThunk(
  'governmentResources/delete',
  params => application.call(API.GOVERNMENT_RESOURCES.DELETE, params)
)


// ── Thunks: Federal Agency Links ───────────────────────────────────────────────
// now using your existing API constants
export const getAgencyLinksList = createAsyncThunk(
  'federalAgencyResources/getList',
  () => application.call(API.FEDERAL_AGENCY_RESOURCES.GET_LIST, {})
)
export const updateAgencyLink = createAsyncThunk(
  'federalAgencyResources/update',
  params => application.call(API.FEDERAL_AGENCY_RESOURCES.UPDATE, params)
)


// ── Internal handlers for Government Resources ─────────────────────────────────
function onGetGovernmentResourcesList(state, action) {
  state.governmentResources = action.payload || []
}
function onGetGovernmentResource(state, action) {
  state.governmentResourceDetail = action.payload
}
function onCreateGovernmentResource(state, action) {
  state.governmentResources.push(action.payload)
}
function onUpdateGovernmentResource(state, action) {
  const idx = state.governmentResources.findIndex(r => r.id === action.payload.id)
  if (idx !== -1) state.governmentResources[idx] = action.payload
}
function onDeleteGovernmentResource(state, action) {
  state.governmentResources = state.governmentResources.filter(
    r => r.id !== action.payload.id
  )
}


// ── Actions Export ──────────────────────────────────────────────────────────────
export const actions = {
  getGovernmentResourcesList,
  getGovernmentResource,
  createGovernmentResource,
  updateGovernmentResource,
  deleteGovernmentResource,

  // Federal Agency Links
  getAgencyLinksList,
  updateAgencyLink
}


// ── Reducer ─────────────────────────────────────────────────────────────────────
export default createReducer(INITIAL_STATE, builder => {
  // Government Resources
  builder
    .addCase(getGovernmentResourcesList.fulfilled, onGetGovernmentResourcesList)
    .addCase(getGovernmentResource.fulfilled, onGetGovernmentResource)
    .addCase(createGovernmentResource.fulfilled, onCreateGovernmentResource)
    .addCase(updateGovernmentResource.fulfilled, onUpdateGovernmentResource)
    .addCase(deleteGovernmentResource.fulfilled, onDeleteGovernmentResource)

  // Federal Agency Links
  builder
    .addCase(getAgencyLinksList.fulfilled, (state, action) => {
      // action.payload = { items: [...], count }
      state.agencyLinks = action.payload.items
    })
    // .addCase(updateAgencyLink.fulfilled, (state, action) => {
    //   // action.meta.arg = { agencyId, govLink }
    //   const { agencyId, govLink } = action.meta.arg
    //   const idx = state.agencyLinks.findIndex(a => a.id === agencyId)
    //   if (idx !== -1) {
    //     state.agencyLinks[idx].govLink = govLink
    //   }
    // })
    .addCase(updateAgencyLink.fulfilled, (state, action) => {
  const { agencyId, govLink, smallBusinessLink } = action.meta.arg
  const idx = state.agencyLinks.findIndex(a => a.id === agencyId)
  if (idx !== -1) {
    if (typeof govLink !== 'undefined') state.agencyLinks[idx].govLink = govLink
    if (typeof smallBusinessLink !== 'undefined') {
      state.agencyLinks[idx].smallBusinessLink = smallBusinessLink
    }
  }
})
})





